import styled from 'styled-components';
import { Form } from 'formik';

export const InfoContent = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 40%;
	background: #FFFFFF;
	padding: 0 40px 64px 40px !important; // bottom 64px footer 高度
	padding-bottom: 64px;

	@media ${props => props.theme.device.mobile} {
		width: 100%;
		padding: 20px 0 20px 0 !important; // footer 高度
	}
	@media ${props => props.theme.device.smTablet} {
		width: 236px;
		padding: 0 20px 64px 20px !important; // bottom 64px footer 高度
	}
	@media ${props => props.theme.device.tablet} {
		width: 340px;
		padding: 0 20px 64px 20px !important; // bottom 64px footer 高度
	}
	@media ${props => props.theme.device.desktop} {
		width: 460px;
	}
`;

export const LogoContent = styled.img`
	width: 148px;
	height: 40px;
`;

export const TitleContent = styled.div`
	font-weight: bold;
	font-size: 18px;
	color: #101010;
	margin-top: 8px;

	@media ${props => props.theme.device.mobile} {
		font-size: 20px;
		margin-top: 12px;
	}
`;

export const ImageContent = styled.img`
	width: 380px;
	height: 307px;
	margin-top: 12px;

	@media ${props => props.theme.device.mobile} {
		display: none;
	}
	@media ${props => props.theme.device.smTablet} {
		width: 196px;
		height: 158px;
	}
	@media ${props => props.theme.device.tablet} {
		width: 300px;
		height: 242px;
	}
`;

export const TextContent = styled.div`
	font-size: 16px;
	color: #676767;	
	margin-top: 12px;

	@media ${props => props.theme.device.mobile} {
		display: none;
	}
`;

export const Content = styled.div`
	display: flex;
	flex-direction: row;
	height: 100%;
	min-height: 100vh;

	@media ${props => props.theme.device.mobile} {
		width: 100%;
		height: 122px;
		flex-direction: column;
	}
`;

export const StyledForm = styled(Form)`
	width: 350px;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;

	@media ${props => props.theme.device.mobile} {
		width: 335px;
	}
	@media ${props => props.theme.device.smTablet}
	{
		width: 300px;
	}
`;

export const InputContent = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100vh;
	background: #F5F5F5;
	align-items: center;
	justify-content: center;
	padding-bottom: 64px; // footer 高度
	@media ${props => props.theme.device.mobile} {
		justify-content: flex-start;
		padding-top: 48px;
	}
`;

export const TitleText = styled.div`
	width: 100%;
	color: #101010;
	font-size: 18px;
	font-weight: bold;
	margin-top: 12px;
	margin-bottom: 44px;
	white-space: pre-line;
	line-height: 40px;
`;

export const StyledLoginWrapper = styled.div`
	width: 350px;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;

	@media ${props => props.theme.device.mobile} {
		width: 100%;
		padding: 0 20px;
	}
	@media ${props => props.theme.device.smTablet}
	{
		width: 300px;
	}
`;

export const ButtonDesc = styled.div`
  margin-top: 12px;
	font-weight: 400;
	font-size: 14px;
	line-height: 21px;
	color: #333333;
	text-align: left;
`;

export const LoginTypeTabWrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex: 1;
	margin-bottom: 32px;
`;

export const LoginTypeTab = styled.div`
	height: 40px;
	width: 175px;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	flex: 1;
	color: #222;
	font-size: 16px;
	font-weight: 300;
	cursor: pointer;
	&.active {
		color: ${props => props.theme.colors.primary};
		border-bottom: 3px solid ${props => props.theme.colors.primary};
	}
`;
